import { LoadFileFormatField } from './LoadFileFormatField';

export class RelativitySettings {
  public readonly id: string;
  public projectId: string;
  public workspace: { name: string, id: string };
  public readonly name: string;
  public fields: LoadFileFormatField[];
  public readonly hasHeaderRow: boolean;
  public selectMode: Array<{ name: string, id: string }>;
  public overlayIdentifier: Array<{ name: string, id: string }>;
  public multiSelect: Array<{ name: string, id: string }>;
  public rootFolder: Array<{ name: string, id: string }>;
  public subFolder: Array<{ id: string, name: string }>;

  constructor(projectId: string, workspace: { name: string, id: string }, name: string, fields: LoadFileFormatField[],
              hasHeaderRow: boolean, selectMode: Array<{ name: string, id: string }>, overlayIdentifier: Array<{ name: string, id: string }>, multiSelect: Array<{ name: string, id: string }>,
              rootFolder: Array<{id: string, name: string}>, subFolder: Array<{id: string, name: string}>) {
    this.projectId = projectId;
    this.workspace = workspace;
    this.name = name;
    this.fields = fields;
    this.hasHeaderRow = hasHeaderRow;
    this.rootFolder = rootFolder;
    this.subFolder = subFolder;
    this.selectMode = selectMode;
    this.overlayIdentifier = overlayIdentifier;
    this.multiSelect = multiSelect;
  }
}
